export default __webpack_public_path__ + "static/media/trendelenburg-demo.041cfec9.png";